import { apiGet, apiPatch, apiPost } from "@/lib/api";

export type WorkflowTriggerType = "incoming_webhook" | "schedule" | "message_created";

export interface PublicWorkflow {
  id: string;
  name: string;
  enabled: boolean;
  trigger_type: WorkflowTriggerType;
  trigger: Record<string, unknown>;
  action_type: "room_post";
  action: Record<string, unknown>;
  incoming_path: string | null;
  created_by: string;
  created_at: number;
  updated_at: number;
  last_error: string | null;
  last_run_at: number | null;
}

export interface WorkflowRun {
  id: string;
  workflow_id: string;
  status: "running" | "ok" | "error";
  error: string | null;
  trigger_event_id: string | null;
  message_id: string | null;
  created_at: number;
  finished_at: number | null;
}

export function listWorkflows() {
  return apiGet<{ workflows: PublicWorkflow[] }>("/v1/workflows");
}

export function createWorkflow(body: unknown) {
  return apiPost<{ workflow: PublicWorkflow; incoming_url_secret?: string; incoming_path?: string; signing?: Record<string, string> }>("/v1/workflows", body);
}

export function updateWorkflow(id: string, body: unknown) {
  return apiPatch<{ workflow: PublicWorkflow }>(`/v1/workflows/${encodeURIComponent(id)}`, body);
}

export function listWorkflowRuns(id: string) {
  return apiGet<{ runs: WorkflowRun[] }>(`/v1/workflows/${encodeURIComponent(id)}/runs`);
}

export function rotateWorkflowSecret(id: string) {
  return apiPost<{ workflow: PublicWorkflow; incoming_url_secret: string; incoming_path: string; signing: Record<string, string> }>(
    `/v1/workflows/${encodeURIComponent(id)}/rotate-secret`,
    {},
  );
}
